// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3u-1";
export var rateTableServiceLevelDropdown = "_3u-3";
export var rateTableTypeDropdown = "_3u-0";
export var rateTableValueModeDropdown = "_3u-2";